export default "__VITE_ASSET__D0akIwh0__"